import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form.tsx';
import { Input } from '@/components/ui/input.tsx';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export const PlantFormStepFinancialInformation = ({
  showTitle = false,
}: {
  showTitle?: boolean;
}) => {
  const form = useFormContext<TPlant>();

  return (
    <div id="financialInformation" className="space-y-4 rounded-lg bg-white p-4 py-4 pb-8">
      {showTitle && <h3 className="font-semibold">Financial Information</h3>}
      <FormField
        control={form.control}
        name="financialInformation.tariffRate"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="">
              Tariff rate <span className="font-normal">(€ per kWh)</span>
            </FormLabel>
            <FormControl>
              <Input
                type="number"
                className="bg-white"
                placeholder="Enter the tariff rate"
                {...field}
                value={field.value ?? undefined}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="financialInformation.expectedROI"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Expected ROI<span className="font-normal"> (%)</span>
            </FormLabel>
            <FormControl>
              <Input
                type="number"
                className="bg-white"
                placeholder="Enter the expected ROI"
                {...field}
                value={field.value ?? undefined}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="financialInformation.operationalCosts"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Operational costs <span className="font-normal">(€)</span>
            </FormLabel>
            <FormControl>
              <Input
                type="number"
                className="bg-white"
                placeholder="Enter the operational costs"
                {...field}
                value={field.value ?? undefined}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
